import { render, staticRenderFns } from "./HeadInfo.vue?vue&type=template&id=556bda86&scoped=true&"
import script from "./HeadInfo.vue?vue&type=script&lang=js&"
export * from "./HeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./HeadInfo.vue?vue&type=style&index=0&id=556bda86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556bda86",
  null
  
)

export default component.exports